<template>
  <div class="wc-row">
    <div class="wc-col wc-col__sm-12 wc-col__md-12">
      <RequestAccompaniedDrivingList></RequestAccompaniedDrivingList>
    </div>
  </div>
</template>

<script setup lang="ts">
import RequestAccompaniedDrivingList from '@/components/policy/self-services/RequestAccompaniedDrivingList.vue'
</script>
